import { render, staticRenderFns } from "./DefaultError.vue?vue&type=template&id=7941d629&scoped=true"
import script from "./DefaultError.vue?vue&type=script&lang=ts"
export * from "./DefaultError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7941d629",
  null
  
)

export default component.exports